import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getChatSessionTimeSeries = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/analytics/chatSessionsTimeSeries', METHOD_TYPES.GET, data, callback);
};

export const getUserEngagementStats = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/analytics/userEngagementStats', METHOD_TYPES.GET, data, callback);
};

export const getUserRetention = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/analytics/retentionCohorts', METHOD_TYPES.GET, data, callback);
};



// WEBPACK FOOTER //
// ./src/data/redux/usage_details/api.js